import { FC } from 'react';
import { FieldError } from 'react-hook-form';
import { Text } from '@mantine/core';

type Props = {
  field: FieldError | undefined;
};

const FormErrorText: FC<Props> = ({ field }) => {
  if (field === undefined) return null;

  return (
    <>
      <Text c='red.6' fz={12} fw={450}>
        {field.message}
      </Text>
    </>
  );
};

export default FormErrorText;
